<template>
  <form class="form-horizontal">
    <div class="form-group">
      <label class="col-xs-12">
        集合地点 <button type="button" class="btn btn-xs btn-primary" @click="route.assemblePlace.push({detail: ''})">添</button>
      </label>
      <div class="col-xs-4 xp-col" v-for="item in route.assemblePlace" track-by="$index">
        <div class="input-group">
          <input type="text" class="form-control" v-model="item.detail" required="required">
          <span class="input-group-addon" @click="route.assemblePlace.$remove(item)">&times;</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-12">
        集合时间 <button type="button" class="btn btn-xs btn-primary" @click="route.assembleTime.push({assembleTime: ''})">添</button> (集合时间必填)
      </label>
    </div>
    <div class="form-group" v-for="item in route.assembleTime" track-by="$index">
      <div class="pull-left">
        <div class="form-control-static text-danger">
        {{$index + 1}}
        </div>
      </div>
      <div class="col-xs-3">
        <div class="input-group">
          <span class="input-group-addon">集合时间</span>
          <input type="time" class="form-control" v-model="item.assembleTime" required="required">
        </div>
      </div>
      <div class="col-xs-7">
        <div class="input-group">
          <span class="input-group-addon">时间段</span>
          <input type="text" class="form-control" v-model="item.assemblePeriod" placeholder="请填写">
        </div>
      </div>
      <div class="col-xs-1">
        <button class="btn btn-danger" type="button" @click="route.assembleTime.$remove(item)">删除</button>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" type="button" @click="click(submit)($event)" class="btn btn-primary">保存</button>
        <button type="button" type="button" @click="click(submit)($event, '/route/' + this.$route.params.id + '/itinerary')"  class="btn btn-success">保存并下一步</button>
      </div>
    </div>
  </form>
</template>

<script>
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  export default {
    props: ['route'],
    components: {
    },
    methods: {
      updatePlaces () {
        let routeId = this.$route.params.id
        return this.$http.put(`${config.apiWe}/product/route/${routeId}/assemblePlace`, {
          assemblePlaces: this.route.assemblePlace
        })
      },
      updateTimes () {
        let routeId = this.$route.params.id
        return this.$http.put(`${config.apiWe}/product/route/${routeId}/assembleTime`, {
          assembleTimes: this.route.assembleTime
        })
      },
      submit (next) {
        return Promise.all([this.updatePlaces(), this.updateTimes()])
          .then(() => {
            next && this.$route.router.go(next)
          })
      },
      click: utils.click
    }
  }
</script>

<style scoped>
  .xp-col {
    margin-bottom: 10px;
  }
  .xp-col .input-group-addon {
    cursor: pointer;
  }
</style>



/** WEBPACK FOOTER **
 ** Assembling.vue?36694098
 **/